/**
 * GameState — state machine for game states (exploring, battle, dialogue, etc.)
 *
 * States are layered on a single Phaser scene. Each state controls what's
 * visible and how input is handled. Transitions are animated.
 */

declare const Phaser: any;

export interface GameState {
  key: string;
  enter(scene: any, data?: any): void;
  exit(scene: any): void;
  update(scene: any, time: number, delta: number): void;
}

export class GameStateManager {
  private states: Map<string, GameState> = new Map();
  private _current: GameState | null = null;
  private scene: any;

  constructor(scene: any) {
    this.scene = scene;
  }

  get current(): GameState | null {
    return this._current;
  }

  get currentKey(): string | null {
    return this._current ? this._current.key : null;
  }

  register(state: GameState): void {
    this.states.set(state.key, state);
  }

  switch(key: string, data?: any): void {
    const next = this.states.get(key);
    if (!next) {
      console.warn(`GameState "${key}" not registered`);
      return;
    }
    if (this._current) {
      this._current.exit(this.scene);
    }
    this._current = next;
    this._current.enter(this.scene, data);
  }

  update(time: number, delta: number): void {
    if (this._current) {
      this._current.update(this.scene, time, delta);
    }
  }
}
